import { ResourceSkill } from "./resource-skill";

import { BaseEntity } from "@app/models/rest/base-entity";
import {
  ResourceZone,
  ResourceZoneDetailProjection
} from "@app/models/rest/resource-zone";
import { Team } from "@app/models/rest/team";
import { LocationModel } from "@app/models/rest/location";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel,
  ProjectionRelType
} from "@lagoshny/ngx-hateoas-client";
import { ResourceRule } from "@app/models/rest/resource-rule";

export enum WorkMode {
  Offline = "Offline",
  Online = "Online"
}

@HateoasResource("resources")
export class ResourceModel extends BaseEntity {
  name: string;
  imageUrl: string;
  cost: number;
  skillsList: Array<ResourceSkill>;
  zonesList: Array<ResourceZone>;
  team: Team;
  location: ProjectionRelType<LocationModel>;
  workMode: WorkMode;
  /**
   * Operative efficiency percentage. 100/null = no adjustment. Constrained to [50, 150]
   * server-side.
   * Higher values mean faster operatives (shorter on-site duration); lower values give the
   * operative more time per job.
   */
  efficiencyPercentage: number | null;
  /** ISO date (YYYY-MM-DD) from which {@link efficiencyPercentage} applies; null = always. */
  efficiencyEffectiveFrom?: string;
  /** ISO date (YYYY-MM-DD) until which {@link efficiencyPercentage} applies; null = indefinitely. */
  efficiencyEffectiveTo?: string;
}

@HateoasProjection(ResourceModel, "detail")
export class Resource_DetailProjection extends BaseEntity {
  name: string;
  imageUrl: string;
  cost: number;
  skillsList: Array<ResourceSkill>;
  resourceRules: Array<ResourceRule>;
  zonesList: Array<ResourceZoneDetailProjection>;
  @ProjectionRel(Team)
  team: Team;
  location: LocationModel;
  workMode: WorkMode;
  efficiencyPercentage: number | null;
  efficiencyEffectiveFrom?: string;
  efficiencyEffectiveTo?: string;
}

@HateoasProjection(ResourceModel, "basic")
export class Resource_BasicProjection extends BaseEntity {
  name: string;
  imageUrl: string;
  location: LocationModel;
  workMode: WorkMode;
  efficiencyPercentage: number | null;
}
